<template src="./template.html"></template>

<script>
/* eslint-disable */

import {mapGetters} from "vuex";

export default {
  name: 'NotificationCard',
  computed: {
    ...mapGetters([
      'get_notification_bar_message',
      'get_notification_bar',
    ]),
  },
  methods: {
    close() {
      this.$store.commit('CLOSE_NOTIFICATION_BAR')
    },
  },
};
</script>
